import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const INITIATE_PAYMENT = BASE_URL + "/payment/create"
export const UPDATE_PAYMENT_STATUS = BASE_URL + "/payment/updatestatus"